import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './sections/Navbar';
import Footer from './sections/Footer';
import FloatingWhatsApp from './sections/FloatingWhatsApp';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import WhyChooseUsPage from './pages/WhyChooseUsPage';
import PracticeAreasPage from './pages/PracticeAreasPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import { BlogIndex, BlogPost } from './sections/Blog';
import PracticeAreaDetail from './sections/PracticeAreaDetail';
import ExpatEnPage from './sections/ExpatEnPage';
import ScrollToTop from './components/ScrollToTop';
import LanguageForcer from './components/LanguageForcer';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
            <Route path="/practice-areas" element={<PracticeAreasPage />} />
            <Route path="/practice-areas/:slug" element={<PracticeAreaDetail />} />
            <Route path="/guides/:slug" element={<PracticeAreaDetail />} />
            <Route path="/services/:slug" element={<PracticeAreaDetail />} />
            <Route path="/en/services/:slug" element={<ExpatEnPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* French mirror: same page components, forced to 'fr' via LanguageForcer. */}
            <Route path="/fr" element={<LanguageForcer lang="fr" />}>
              <Route index element={<Home />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="why-choose-us" element={<WhyChooseUsPage />} />
              <Route path="practice-areas" element={<PracticeAreasPage />} />
              <Route path="practice-areas/:slug" element={<PracticeAreaDetail />} />
              <Route path="guides/:slug" element={<PracticeAreaDetail />} />
              <Route path="services/:slug" element={<PracticeAreaDetail />} />
              <Route path="blog" element={<BlogIndex />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="testimonials" element={<TestimonialsPage />} />
              <Route path="contact" element={<ContactPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <FloatingWhatsApp />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
